import React, {Component} from 'react'
//import Button from '@material-ui/core/Button';
//import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';


const wStyles = theme => ({
    textLink:{
        //height:30,
        width:"90%",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:15,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
            cursor:"pointer"
        }  
    }
})

class FirstStageOption extends Component {
    constructor(props) {
        super(props)
        this.state = {
            optionTitle:null,
            optionRoute:null,
            optionHover:false,
            showInput:false,
            boundary:null,
            position:{
                x:0,
                y:0,
            },
            refPos:{
                x:0,
                y:0
            },
        }
        this.optionRef = React.createRef()
    }

    componentDidMount(){
        this.initialState()
        this.getBoundary()

    }

    componentDidUpdate(prevProps){
        if(prevProps.otherDragging !== this.props.otherDragging)
        {
            this.getBoundary()
        }
        if(prevProps.mousePos !== this.props.mousePos)
        {
            this.detectHover()
        }

    }

    componentWillUnmount(){

    }

    getBoundary=()=>{
        let rect = this.optionRef.current.getBoundingClientRect()
        let boundaryObj = {
            T:rect.top,
            B:rect.top+40
        }
        this.setState({
            boundary:boundaryObj
        })

        //this.props.getBoundary(boundaryObj)
    }

    initialState=()=>{
        if(this.props.optionInfo)
        {
            this.setState({
                optionTitle:this.props.optionInfo.title,
                optionRoute:this.props.optionInfo.route
            })
        }
    }

    detectHover=()=>{
        if(this.state.boundary)
        {
            if(this.props.otherDragging)
            {
                if(this.props.otherDragging !== this.props.optionInfo.id)
                {
                    if(this.props.mousePos.y > this.state.boundary.T && this.props.mousePos.y < this.state.boundary.B)
                    {
                        let msg = {
                            status:true,
                            id:this.props.optionInfo.id,
                            sequence:this.props.sequence
                        }
                        this.setState({
                            optionHover:true
                        })
                        this.props.getHoverMsg(msg)
                    }
                    else
                    {
                        if(this.state.optionHover)
                        {
                            this.setState({
                                optionHover:false
                            })
                            let msg = {
                                status:false,
                                id:this.props.optionInfo.id,
                                sequence:this.props.sequence
                            }
                            this.props.getHoverMsg(msg)
                        }
                    }
                }
                else
                {
                    this.setState({
                        optionHover:false
                    })
                }
            }
            else
            {
                this.setState({
                    optionHover:false
                })
            }
        }
    }

    onMouseDown=(e)=>{   
        e.stopPropagation()
        e.preventDefault()
        console.log("e.button : ",e.button)
        
        //console.log('ControllerUnitContainer headerMouseDown')
        if(e.button === 0)
        {
            if(!this.props.otherDragging)
            {
                let rect = this.optionRef.current.getBoundingClientRect();
                this.setState({
                    //containerDragging:true,
                    //containerFocusing:true,
                    refPos:{
                        //x:e.clientX-this.props.offset.x-this.state.position.x,
                        //y:e.clientY-this.props.offset.y-this.state.position.y
                        x:e.clientX-rect.left,
                        y:e.clientY-rect.top
                    },
                    showInput:false,
                })   

                let msg ={
                    conID:this.props.optionInfo.id,
                    sequence:this.props.sequence,
                    containerDragging:true,
                    title:this.state.optionTitle,
                    route:this.state.optionRoute,
                    color:this.props.bgColor
                }
                this.props.containerDragging(msg)
            }
        }
        else if(e.button === 2)
        {
            this.setState({
                showInput:true,
                refPos:{
                    x:0,
                    y:0
                },
                optionHover:false
            })
        }
    }

    onMouseUp=(e)=>{
        e.stopPropagation()
        e.preventDefault()

        this.setState({
            //containerDragging:false,
            refPos:{
                x:0,
                y:0
            },
            optionHover:false
        })  
    
        let msg ={
            conID:this.props.optionInfo.id,
            containerDragging:false,
            sequence:this.props.sequence,
        }
        this.props.containerDragging(msg)
    
    }

    onContextMenu=(e)=>{
        e.stopPropagation()
        e.preventDefault()
        console.log("onDoubleClick...")
        this.setState({
            showInput:true,
            refPos:{
                x:0,
                y:0
            },
            optionHover:false
        })
    }

    changeTitle=(e)=>{
        if(this.state.optionTitle !== e.target.value)
        {
            this.setState({
                optionTitle:e.target.value
            })
        }
    }

    changeRoute=(e)=>{
        if(this.state.optionRoute !== e.target.value)
        {
            this.setState({
                optionRoute:e.target.value
            })
        }
    }

    submit=(e)=>{
        if(e.keyCode === 13)
        {
            this.setState({
                showInput:false,
            })   

            let msg ={
                conID:this.props.optionInfo.id,
                sequence:this.props.sequence,
                title:this.state.optionTitle,
                route:this.state.optionRoute,
                color:this.props.bgColor
            }
            this.props.getTitleAndRoute(msg)
        }
    }

    transHeight=()=>{
        if(this.state.optionHover)
        {
            return '40px'
        }
        else
        {
            return '0px'
        }
    }
    
    render(){
        //const {classes} = this.props;
        let firstStageOptionStyle = {
            width:"90%",
            margin:"5px",
            cursor:"pointer"
        }

        let firstStageOptionDraggingStyle = {
            position:"fixed",
            left:this.props.mousePos.x-this.state.refPos.x,
            top:this.props.mousePos.y-this.state.refPos.y,
            width:"450px",
            margin:"5px",
            cursor:"pointer"
        }

        let labelArea = {
            //width:"90%",
            height:"40px",
            fontFamily:"Microsoft JhengHei",
            borderStyle:"soild",
            borderWidth:1,
            borderColor:"black",
            textAlign:"center",
            fontSize:15,
            lineHeight:"30px",
            backgroundColor:this.props.bgColor,
            color:"white"
        }

        let bufferArea = {
            transition:'height 0.5s',
            height:this.transHeight(),
            width:"90%",
            //float:'left',
            //pointerEvents:'none'
        }

        let optionSurfixAreaStyle = {
            backgroundColor:this.props.bgColor,
            width:"90%",
            height:"50px",
        }

        let showInputStyle = {
            display:"flex"
        }

        let hideInputStyle = {
            display:"none"
        }

        let rowTitle = {
            width:"40%",
            border:"1px solid black",
            fontFamily: "Microsoft JhengHei",
        }

        return(
            this.props.optionInfo.id === 99 ?
            <div style={optionSurfixAreaStyle} ref={this.optionRef}></div>
            :
            <div style={this.props.otherDragging === this.props.optionInfo.id? firstStageOptionDraggingStyle:firstStageOptionStyle}  ref={this.optionRef} onContextMenu={this.onContextMenu}> 
                <div style={bufferArea}></div>
                <div style={labelArea} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                    {this.state.optionTitle}{" "}<span style={{color:"#d6d6d6"}}>{this.state.optionRoute}</span>
                </div>
                <div style={this.state.showInput?showInputStyle:hideInputStyle}>
                    <div style={rowTitle} >選項標題</div>
                    <input className={"rowForm"}  type='text' value={this.state.optionTitle} onChange={this.changeTitle} onKeyUp={this.submit}/>
                    <div style={rowTitle}>第一階Route</div>
                    <input className={"rowForm"}  type='text' value={this.state.optionRoute} onChange={this.changeRoute} onKeyUp={this.submit}/>
                </div>
            </div>
        )
    }
}

export default withStyles(wStyles)(FirstStageOption)